module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\r\n    '+
((__t=(total_items))==null?'':_.escape(__t))+
' '+
((__t=(lang.NUM_REGISTERS))==null?'':_.escape(__t))+
'\r\n</div>\r\n<div>\r\n<ul class="pagination">\r\n    ';

    page = parseInt(page);
    if(page===1){
        print('<li class="disabled"><a>&laquo;</a></li>');
    }else{
        print('<li id="prev"><a>&laquo;</a></li>');
    }
    
    for(var i=1; i < page_count + 1; i++){
        var active = "";
        if(i===page){
            active = "active"
        }

        if(i===1 || i=== page_count || i === page -1 || i===page + 1 || i === page -2 || i===page + 2 || i===page){
            print('<li class="' + active + ' page" id="page-' + i +'"><a>' + i + '</a></li>');
        }
   }
    
    if(page==page_count){
        print('<li class="disabled"><a>&raquo;</a></li>');
    }else{
        print('<li id="next"><a>&raquo;</a></li>');
    }
    
__p+='\r\n</ul>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/pagination/pagination.ejs
// module id = 434
// module chunks = 0